import { MB } from '../../constants';

export const formatSize = (bytes: number) => `${(bytes / MB).toFixed(2)} MB`;
